import { render, staticRenderFns } from "./BookingListView.vue?vue&type=template&id=70318fc6&scoped=true"
import script from "./BookingListView.vue?vue&type=script&lang=js"
export * from "./BookingListView.vue?vue&type=script&lang=js"
import style0 from "./BookingListView.vue?vue&type=style&index=0&id=70318fc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70318fc6",
  null
  
)

export default component.exports